import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import InstituteOtpVerificationPopup from "./InstituteOtpVerification";
import "./InstituteOtp&password.css";
import InstituteCreateNewPasswordPopup from "./InstituteNewPasswordCreation";
import { GetInstituteDataAndSendOtp } from "../../Actions/UserA";
import InstitutePasswordCreatedSuccessPopup from "./PasswordCreatedSuccess";

const InstitutepasswordAndOtp = () => {
    const Border = "border-[#E2E2E2] border-[1px] border-solid";
    const [openSignupScreen, setOpenSignupScreen] = useState("OTPScreen");
    const { instituteId } = useParams(); // Get packageId from the URL
    console.log("instituteId received is:",instituteId)

    const {InstituteData } = useSelector((Store) => Store.LoginSignupReducer);
    console.log("InstituteData received is:",InstituteData)

    const Dispatch = useDispatch();

    useEffect(() => {
        // When the component mounts, set the selected package from URL
        if (instituteId) {
            Dispatch(GetInstituteDataAndSendOtp(instituteId));
        }
    }, [instituteId]);

      
    return (
        <div
            className={`LightBg partner-bg`} // Conditional class
            style={{
                backgroundImage: "url('/assets/partnerbg.png')",
                backgroundSize: "cover",
                backgroundPosition: "center",
            }}
        >
            <div
                className="MainParent bgGradient"
            >
                <div
                    className="FormParent bg-transparent md:bg-transparent"
                    style={{ backgroundColor: "transparent" }}
                >
                    <div
                    style={{
                    // width: "50%",
                    // backgroundColor: "white",
                    backgroundColor:  "white",
                    // paddingTop: "2.5rem", // equivalent to pt-10
                    paddingBlock: "2rem", // md:pb-4, xl:pb-8
                    paddingInline: "2rem",
                    display: "flex",
                    alignItems: "center",
                    height: "fit-content",
                    overflowX: "hidden",
                    position: "relative",
                    borderRadius: "9px",
                    // marginTop: "100px",
                    }}
                    className=" md:pt-0 bg-[linear-gradient(91deg,_#F8FAFA_0%,_#D7D9FF_100%)] bg-no-repeat"
                    >
                    
                        {openSignupScreen === "OTPScreen" && (
                            <InstituteOtpVerificationPopup
                            setOpenSignupScreen={setOpenSignupScreen}
                            InstituteData={InstituteData}
                            instituteId={instituteId} />
                        )}

                        {openSignupScreen === "PasswordScreen" && (
                            <InstituteCreateNewPasswordPopup
                            setOpenSignupScreen={setOpenSignupScreen}
                            InstituteData={InstituteData} />
                        )}

                        {openSignupScreen === "PasswordSuccessScreen" && (
                            <InstitutePasswordCreatedSuccessPopup
                            setOpenSignupScreen={setOpenSignupScreen}
                            InstituteData={InstituteData} />
                        )}

                    
                    </div>
                </div>
            </div>
        </div>
      ) 
}

export default InstitutepasswordAndOtp;
